import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PoliticaCookies() {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f5f1ea] min-h-screen text-[#141414]">
      <header className="border-b border-[#141414]/10 bg-[#f5f1ea] sticky top-0 z-40">
        <div className="w-full px-6 md:px-12 lg:px-20 h-[64px] flex items-center justify-between">
          <button onClick={() => navigate('/')} className="inline-flex items-center gap-2 text-[#141414]/60 hover:text-[#141414] text-[13.5px] transition-colors">
            <ArrowLeft size={15} /> Volver
          </button>
          <a href="/" className="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 26 26" fill="none" className="text-[#141414]"><path d="M2 4 L13 22 L24 4 L19 4 L13 14 L7 4 Z" fill="currentColor" /></svg>
            <span className="font-serif text-[18px] tracking-tight">Escalado</span>
          </a>
        </div>
      </header>

      <main className="w-full px-6 md:px-12 lg:px-20 py-16 md:py-24">
        <div className="max-w-[780px]">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#141414]/45 mb-5">Legal</p>
          <h1 className="font-serif text-[36px] md:text-[48px] leading-[1.06] tracking-[-0.02em] mb-12">Política de Cookies</h1>

          <div className="space-y-10 text-[#141414]/80 text-[15.5px] leading-[1.75]">

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">1. ¿Qué son las cookies?</h2>
              <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en tu navegador cuando los visitas. Permiten que el sitio recuerde tu dispositivo y preferencias en visitas posteriores, mejorando así la experiencia de navegación.</p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">2. Responsable</h2>
              <div className="bg-[#ece6db] p-6 space-y-2 text-[14.5px]">
                <p><span className="font-medium text-[#141414]">Titular:</span> Zeus Digital Business Ltd</p>
                <p><span className="font-medium text-[#141414]">Sede principal:</span> Covent Garden, 73, Londres, Reino Unido</p>
                <p><span className="font-medium text-[#141414]">Oficina España:</span> C/ de les Barques, 2, 2ª planta, Ciutat Vella, 46002 Valencia</p>
                <p><span className="font-medium text-[#141414]">Email:</span> cookies@escalado.com</p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">3. Tipos de cookies que utilizamos</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="font-medium text-[#141414] mb-2 text-[16px]">Cookies técnicas o esenciales</h3>
                  <p className="text-[14.5px]">Son imprescindibles para el funcionamiento básico del sitio web. Sin ellas, el sitio no funcionaría correctamente. No requieren consentimiento previo. Entre ellas se incluyen las cookies de sesión, seguridad y preferencias del usuario.</p>
                </div>

                <div>
                  <h3 className="font-medium text-[#141414] mb-2 text-[16px]">Cookies analíticas</h3>
                  <p className="text-[14.5px]">Nos permiten analizar el comportamiento de los usuarios en el sitio (páginas visitadas, tiempo de sesión, origen del tráfico) con el objetivo de mejorar la experiencia. Solo se activan con tu consentimiento previo.</p>
                </div>

                <div>
                  <h3 className="font-medium text-[#141414] mb-2 text-[16px]">Cookies de publicidad y seguimiento</h3>
                  <p className="text-[14.5px]">Utilizadas para mostrarte publicidad relevante dentro y fuera de nuestro sitio web, así como para medir la efectividad de nuestras campañas en plataformas como Taboola. Solo se activan con tu consentimiento explícito.</p>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">4. Tabla de cookies utilizadas</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-[13.5px] border-collapse">
                  <thead>
                    <tr className="border-b border-[#141414]/20">
                      <th className="text-left py-3 pr-4 font-medium text-[#141414]">Nombre</th>
                      <th className="text-left py-3 pr-4 font-medium text-[#141414]">Tipo</th>
                      <th className="text-left py-3 pr-4 font-medium text-[#141414]">Finalidad</th>
                      <th className="text-left py-3 font-medium text-[#141414]">Duración</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#141414]/10 text-[#141414]/75">
                    <tr>
                      <td className="py-3 pr-4">escalado_cookie_consent</td>
                      <td className="py-3 pr-4">Técnica</td>
                      <td className="py-3 pr-4">Almacena tu preferencia de cookies</td>
                      <td className="py-3">12 meses</td>
                    </tr>
                    <tr>
                      <td className="py-3 pr-4">_ga, _gid</td>
                      <td className="py-3 pr-4">Analítica</td>
                      <td className="py-3 pr-4">Google Analytics — estadísticas de uso</td>
                      <td className="py-3">2 años / 24h</td>
                    </tr>
                    <tr>
                      <td className="py-3 pr-4">_tfa</td>
                      <td className="py-3 pr-4">Publicidad</td>
                      <td className="py-3 pr-4">Taboola — seguimiento de conversiones</td>
                      <td className="py-3">13 meses</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">5. Cómo gestionar las cookies</h2>
              <p>Puedes configurar tu navegador para bloquear o eliminar cookies en cualquier momento. Ten en cuenta que desactivar ciertas cookies puede afectar a la funcionalidad del sitio web.</p>
              <ul className="space-y-2 pl-5 border-l-2 border-[#141414]/15 text-[14.5px]">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">Safari</a></li>
                <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">Microsoft Edge</a></li>
              </ul>
              <p>También puedes revocar tu consentimiento en cualquier momento haciendo clic en el botón del pie de página: <strong>"Gestionar cookies"</strong>.</p>
            </section>

            <section className="space-y-4">
              <h2 className="font-serif text-[22px] text-[#141414] tracking-[-0.01em]">6. Actualizaciones de esta política</h2>
              <p>Podemos actualizar esta Política de Cookies para reflejar cambios en las cookies que utilizamos o por otras razones operativas, legales o reglamentarias. Te recomendamos revisar esta página periódicamente.</p>
            </section>

            <div className="border-t border-[#141414]/10 pt-8">
              <p className="text-[13px] text-[#141414]/45">Última actualización: mayo de 2026.</p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
